import { IsInt, ValidateNested } from "class-validator";
import { InputEntity } from "../..";
import OutputLc from "../../lc";
import { Type } from "class-transformer";

export class TransmedProofInput extends InputEntity {
  constructor(
    public readonly participationProof1: File | null,
    public readonly participationProof2: File | null,
    public readonly participationProof3: File | null,
    public readonly participationProof4: File | null,
    public readonly participationProof5: File | null,
    public readonly certificateText: string,
    public readonly review: string
  ) {
    super();
  }
}

export class TransmedProofValidationInput extends InputEntity {
  constructor(public readonly message: string|null = null) {
    super();
  }
}

export class TransmedProofUnvalidated {
  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc;

  @IsInt() public readonly cnt!: number;
}

export class TransmedCertificateBulkItem {
  constructor(
    public readonly registration: number,
    public readonly file: File
  ) {}
}

export class TransmedCertificateBulkInput extends InputEntity {
  constructor(public readonly items: TransmedCertificateBulkItem[]) {
    super();
  }
}
